import { useEffect, useState } from "react";
import CollaboratorsAPI from "../../../services/api/collaborators.api";

import logo from "../../../assets/gm-logo-name.svg";
import termIcon01 from "../../../assets/term_icon_01.png";
import termIcon02 from "../../../assets/term_icon_02.png";
import termIcon03 from "../../../assets/term_icon_03.png";
import timerIcon from "../../../assets/timer_icon.png";
import emailIcon from "../../../assets/email_icon.png";
import { getUniqueRandomNumber } from "../../../utils/randomNumbers";

const iconsTerms = [
  {
    icon: termIcon01,
    text: 'Procura realizar el test en un espacio sin distracciones.',
  },
  {
    icon: termIcon02,
    text: 'Confía en tu primera impresión al responder.',
  },
  {
    icon: termIcon03,
    text: 'Responde de forma honesta y espontánea.',
  },
];

const STEPS = {
  TERMS: 'TERMS',
  QUESTIONS: 'QUESTIONS',
  INTRO_ANSWER_FUNDAMENTALS: 'INTRO_ANSWER_FUNDAMENTALS',
  ANSWER_FUNDAMENTALS: 'ANSWER_FUNDAMENTALS',
  FINISHED: 'FINISHED',
};

const MAX_ANSWER_FUNDAMENTALS = 2;

const CompetenceTest = (props) => {
  const { test } = props;
  const [currentStep, setCurrentStep] = useState(STEPS.TERMS);
  const [questions, setQuestions] = useState([]);
  const [answerFundamentalsIndexs, setAnswerFundamentalsIndexs] = useState([]);
  const [currentAnswerFundamentalsIndex, setCurrentAnswerFundamentalsIndex] = useState(0);
  const [startTestDate, setStartTestDate] = useState(null);
  const [finishTestDate, setFinishTestDate] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [modalContent, setModalContent] = useState({
    title: 'Se ha pasado el tiempo para responder',
    subtitle: 'No sobrepienses la respuesta, responde para continuar',
    buttonText: 'Continuar',
  });
  const [isFinishTimerModalOpen, setIsFinishTimerModalOpen] = useState(false);
  const [isFinalStep, setIsFinalStep] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (test?.sections) {
      const allQuestions = [];
      test.sections.forEach((section) => {
        section.questions.forEach((question) => {
          allQuestions.push(question);
        });
      });
      const questionsRandomise = [...allQuestions];
      for (let i = questionsRandomise.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [questionsRandomise[i], questionsRandomise[j]] = [questionsRandomise[j], questionsRandomise[i]];
      }
      setCurrentQuestionIndex(0);
      setQuestions(questionsRandomise);
    }
  }, [test]);

  const submitForm = () => {
    const answers = [];
    questions.forEach((question) => {
      question.options.forEach((option) => {
        const answer = {
          questionOptionID: option.questionOptionID,
          optionPriority: option.selected ? 1 : 0,
        };
        if (option.selected) {
          if (question.answerFundamental) {
            answer.answerFundamental = question.answerFundamental;
          }
          answer.startQuestionDate = question.startQuestionDate;
          answer.finishQuestionDate = question.finishQuestionDate;
        }
        answers.push(answer);
      });
    });
    const body = {
      collaboratorTestID: test.collaboratorTestID,
      startTestDate,
      finishTestDate,
      answers,
    };
    setLoading(true);
    CollaboratorsAPI.postTestAnswers(body)
      .then(() => {
        setCurrentStep(STEPS.FINISHED);
      })
      .catch((error) => {
        console.error('Error ocurred', error);
        alert('Ocurrió un error al enviar tus respuestas');
        setLoading(false);
      })
  };

  const isOptionSelected = () => {
    const question = questions[currentQuestionIndex];
    return question.options.some(option => option.selected);
  };
  
  const nextQuestionAction = () => {

    if (currentStep === STEPS.TERMS) {
      setStartTestDate(new Date());
      questions[currentQuestionIndex].startQuestionDate = new Date();
      setQuestions(questions);
      setCurrentStep(STEPS.QUESTIONS);
      window.scrollTo(0, 0);
      return;
    }
    if (currentStep === STEPS.QUESTIONS) {
      if (currentQuestionIndex < questions.length - 1) {
        if (isOptionSelected()) {
          questions[currentQuestionIndex].finishQuestionDate = new Date();
          questions[currentQuestionIndex + 1].startQuestionDate = new Date();
          setCurrentQuestionIndex(currentQuestionIndex + 1);
          setQuestions(questions);
          window.scrollTo(0, 0);
        } else {
          alert('Por favor, selecciona una opción');
        }
      } else {
        if (isOptionSelected()) {
        questions[currentQuestionIndex].finishQuestionDate = new Date();
        setQuestions(questions);
        } else {
          alert('Por favor, selecciona una opción');
          return;
        }
        setCurrentStep(STEPS.INTRO_ANSWER_FUNDAMENTALS);
        window.scrollTo(0, 0);
      }
      return;
    }
    if (currentStep === STEPS.INTRO_ANSWER_FUNDAMENTALS) {
      // Filtramos los solo las preguntas donde la opcion seleccionada sea nivel alto o muy alto...
      const questionsHighAndVeryHigh = questions.filter((question, index) => {
        const isHighAndVeryHighOptionSelected = question.options
          .find(opt => ((opt.levelOption === 'Muy alto' || opt.levelOption === 'Alto') && opt.selected));
        if (!!isHighAndVeryHighOptionSelected) {
          // Guardamos el indice original para ubicarlo luego en el arreglo original...
          question.originalIndex = index;
          return true;
        }
        return false;
      });
      // Confirmamos si el arrglo de alto y muy alto tenga alguna pregunta.
      // Si no es caso nos quedamos con el arreglo original...
      const questionTarget = questionsHighAndVeryHigh.length >= 2 ? questionsHighAndVeryHigh : questions;
      // Obtenemos dos indices aleatorios...
      let questionOneIndex = getUniqueRandomNumber(questionTarget.length);
      let questionTwoIndex = getUniqueRandomNumber(questionTarget.length, [questionOneIndex]);
      if (questionOneIndex === -1 || questionTwoIndex === -1) {
        questionOneIndex = 0;
        questionTwoIndex = questionTarget.length > 1 ? 1 : 0;
      }
      // Reafirmamos los indices generados en busca de indices originales...
      questionOneIndex = questionTarget[questionOneIndex]?.originalIndex || questionOneIndex;
      questionTwoIndex = questionTarget[questionTwoIndex]?.originalIndex || questionTwoIndex;
      // Guardamos los indices en el estado del componente y actualizamos los demas...
      setAnswerFundamentalsIndexs([questionOneIndex, questionTwoIndex]);
      questions[questionOneIndex].answerFundamental = '';
      questions[questionTwoIndex].answerFundamental = '';
      setQuestions(questions);
      setFinishTestDate(new Date());
      setCurrentStep(STEPS.ANSWER_FUNDAMENTALS);
      window.scrollTo(0, 0);
      return;
    }
    if (currentStep === STEPS.ANSWER_FUNDAMENTALS) {
      if (questions[answerFundamentalsIndexs[currentAnswerFundamentalsIndex]].answerFundamental.length < 1) {
        alert('Por favor, fundamenta tu respuesta');
        return;
      }
      if (questions[answerFundamentalsIndexs[currentAnswerFundamentalsIndex]].answerFundamental.length < 150) {
        alert('Por favor, fundamenta tu respuesta con al menos 150 caracteres');
        return;
      }
      if (currentAnswerFundamentalsIndex + 1 === MAX_ANSWER_FUNDAMENTALS) {
        submitForm();
        return;
      }
      setIsFinalStep(true);
      setCurrentAnswerFundamentalsIndex(currentAnswerFundamentalsIndex + 1);
      window.scrollTo(0, 0);
      return;
    }

  };

  const onChangeOption = (indexOption) => (e) => {
    const question = questions[currentQuestionIndex];
    question.options = question.options.map((option, index) => {
      const { id, questionOptionID, spanish, levelOption } = option;
      const localOption = { id, questionOptionID, spanish, levelOption };
      if (index === indexOption) {
        localOption.selected = true;
      }
      return localOption;
    });
    setQuestions([...questions]);
  };

  const onFinishQuestionTime = () => {
    setModalContent({
      title: 'Se ha pasado el tiempo para responder',
      subtitle: 'No sobrepienses la respuesta, responde para continuar',
      buttonText: 'Continuar',
    });
    setIsFinishTimerModalOpen(true);
  };

  const onFinishTestTime = () => {
    setModalContent({
      title: 'Se ha agotado el tiempo máximo de la prueba',
      subtitle: 'Igualmente puedes continuar. Recuerda no sobrepensar las respuestas.',
      buttonText: 'Continuar',
    });
    setIsFinishTimerModalOpen(true);
  };

  const handleCloseFinishTimeModal = () => {
    setIsFinishTimerModalOpen(false);
  };

  const onChangeFundamentalInput = (e) => {
    if (e.target.value.length <= 700) {
      const question = questions[answerFundamentalsIndexs[currentAnswerFundamentalsIndex]];
      question.answerFundamental = e.target.value;
      setQuestions([...questions]);
    }
  };

  const getButtonText = () => {
    if (loading) {
      return 'Enviando...';
    }
    if (currentStep === STEPS.TERMS) {
      return 'Comenzar Test';
    }
    if (isFinalStep) {
      return 'Enviar Respuestas';
    }
    return 'Continuar';
  };

  return (
    <>
      <div className="gm-test-container">
        <div className="test-header">
          <img src={logo} alt="growme-logo" />
          {
            currentStep !== STEPS.TERMS && currentStep !== STEPS.FINISHED
              && <TestTimer onFinishTime={onFinishTestTime} />
          }
        </div>
        <div className="test-main">
          <div className="test-card">
            <div className="test-card-header">
              {
                currentStep === STEPS.TERMS
                  && <h1>SEGUNDA PARTE: SITUACIONES DEL ENTORNO LABORAL</h1>
              }
              {
                currentStep === STEPS.QUESTIONS
                  && <p>Pregunta {currentQuestionIndex + 1}</p>
              }
            </div>
            <div className="test-card-body">
              {
                currentStep === STEPS.TERMS
                  && <TestTerms />
              }
              {
                currentStep === STEPS.QUESTIONS
                  && <Question question={questions[currentQuestionIndex]} onChangeOption={onChangeOption} onFinishTime={onFinishQuestionTime} resetTimer={currentQuestionIndex} />
              }
              {
                currentStep === STEPS.INTRO_ANSWER_FUNDAMENTALS
                  && <IntroAnswerFundamentals />
              }
              {
                currentStep === STEPS.ANSWER_FUNDAMENTALS
                  && <AnswerFundamentals
                    question={questions[answerFundamentalsIndexs[currentAnswerFundamentalsIndex]]}
                    onChangeFundamentalInput={onChangeFundamentalInput} />
              }
              {
                currentStep === STEPS.FINISHED
                  && <Finished />
              }
            </div>
            <div className="test-card-footer">
              {
                currentStep !== STEPS.FINISHED
                  && <button onClick={nextQuestionAction} disabled={loading}>{ getButtonText() }</button>
              }
            </div>
          </div>
        </div>
      </div>
      {
        isFinishTimerModalOpen
        && <NotificationModal
          icon={<img src={timerIcon} alt="timer-icon" />}
          title={modalContent.title}
          subtitle={modalContent.subtitle}
          buttonText={modalContent.buttonText}
          onClose={handleCloseFinishTimeModal}
        />
      }
    </>
  );
}

const TestTerms = () => {
  return (
    <>
      <div className="gm-instructions">
        <p>En esta sección encontrarás diferentes situaciones que pueden ocurrir en contextos de trabajo.</p>
        <p>Tu tarea será seleccionar la alternativa que mejor represente cómo actuarías en una situación similar.</p>
        <p><strong>¿Cómo responder?</strong></p>
        <p>Lee atentamente cada situación antes de elegir tu respuesta.</p>
        <p>En cada caso tendrás <strong>hasta 3 minutos</strong> para seleccionar la alternativa con la que más te identifiques.</p>
        <p>Recuerda que <strong>no existen respuestas correctas o incorrectas</strong>. El objetivo es comprender mejor tu forma habitual de actuar frente a distintas situaciones laborales.</p>
        <p>Al finalizar esta sección, recibirás un <strong>informe con los resultados de tu evaluación</strong>.</p>
        <p>¡Tómate tu tiempo para reflexionar y responde con honestidad!</p>
      </div>
      <p><strong>Antes de comenzar</strong></p>
      <div className="icons-terms">
        {
          iconsTerms.map((icon, index) => {
            return (
              <div key={index} className="icon-term">
                <img src={icon.icon} alt={`icon-term-${index}`} />
                <p>{icon.text}</p>
              </div>
            );
          })
        }
      </div>
      <p><strong>¿Listo(a) para comenzar?</strong></p>
    </>
  );
};

const Question = (props) => {
  const { question, onChangeOption, onFinishTime, resetTimer } = props;
  return (
    <>
      <h2>{question.spanish}</h2>
      <QuestionTimer onFinishTime={onFinishTime} resetTimer={resetTimer} />
      <div>
        {question.options.map((option, index) => (
          <div className="question-option" key={index} onClick={onChangeOption(index)}>
            <input
              type="radio"
              id={`option-${option.id}`}
              name={`question-${question.id}`}
              value={option.id}
              onChange={onChangeOption(index)}
              checked={option.selected || false}
            />
            <label htmlFor={`option-${option.id}`}>{option.spanish}</label>
          </div>
        ))}
      </div>
    </>
  );
};

const TestTimer = ({ onFinishTime }) => {
  const TIME = parseInt(process.env.REACT_APP_TEST_TIMEOUT_MINUTES, 10) || 60;
  const [timeLeft, setTimeLeft] = useState(TIME * 60);

  useEffect(() => {
    if (timeLeft === 0) {
      onFinishTime();
      return;
    }
    const timerId = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  return (
    <div className="test-timer">
      {
        timeLeft > 0
          ? <p>Quedan <span>{formattedTime}</span> para finalizar el test.</p>
          : <p>Tiempo agotado</p>
      }
    </div>
  );
};

const QuestionTimer = ({ onFinishTime, resetTimer }) => {
  const TIME = parseInt(process.env.REACT_APP_QUESTION_TIMEOUT_SECONDS, 10) || 180;
  const [timeLeft, setTimeLeft] = useState(TIME);
  const [intervalId, setIntervalId] = useState();

  useEffect(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setTimeLeft(TIME);
    const interval = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);
    setIntervalId(interval);
    return () => clearInterval(interval);
  }, [resetTimer]);

  useEffect(() => {
    if (timeLeft === 0) {
      clearInterval(intervalId);
      onFinishTime();
    }
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  return (
    <div className="question-timer">
      <span>{formattedTime}</span>
      <small>{ timeLeft < 60 ? 'segundos' : 'minutos' }</small>
    </div>
  );
};

const IntroAnswerFundamentals = () => {
  return (
    <div className="intro-answer-fundamentals">
      <h2>Profundizando en sus decisiones</h2>
      <p>En esta sección buscamos comprender con mayor profundidad las razones que hay detrás de algunas de sus elecciones realizadas durante el test.</p>
      <p><strong>Detalles importantes:</strong></p>
        <p>Esta parte del test <strong>no tiene límite de tiempo por pregunta.</strong></p>

      <p><strong>¿Qué deberá hacer?</strong></p>
      <p>Se han seleccionado al azar algunas de sus respuestas anteriores. En cada caso, deberá explicar brevemente por qué eligió actuar de esa manera.</p>
      <p>Por ejemplo: <i>“Elegí esta alternativa porque considero importante que mis ideas sean tomadas en cuenta y que mi opinión sea percibida de manera positiva.”</i></p>
      <p>Recuerde que <strong>no existen respuestas correctas o incorrectas</strong>. El objetivo de esta evaluación es comprender mejor su forma de actuar en el entorno laboral y ofrecer información que apoye su desarrollo profesional.</p>
      
    </div>
  )
};

const AnswerFundamentals = (props) => {
  const { question, onChangeFundamentalInput } = props;
  const option = question.options.find(opt => opt.selected);
  return (
    <div className="answer-fundamentals">
      <h2>{question.spanish}</h2>
      <div className="question-option">
        <input
          type="radio"
          id={`option-${option.id}`}
          name={`question-${question.id}`}
          value={option.id}
          checked
          disabled
        />
        <label htmlFor={`option-${option.id}`}>{option.spanish}</label>
      </div>
      <p>Fundamenta tu respuesta (al menos 150 caracteres)</p>
      <textarea
        className="fundamental-text"
        name="fundamental-text"
        id="fundamental-text"
        value={question.answerFundamental || ''}
        onChange={onChangeFundamentalInput}></textarea>
      <p className="character-counter">{`${question.answerFundamental.length}/700`}</p>
    </div>
  );
};

const Finished = () => {
  return (
    <div className="finished-test">
      <h2>Test finalizado</h2>
      <img src={emailIcon} alt="icon" />
      <p><strong>Growme</strong> ha sido completado correctamente.</p>
      <p>Tus resultados serán enviados a tu correo electrónico en breve.</p>
    </div>
  );
};

const NotificationModal = ({ icon, title, subtitle, buttonText, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-icon">{icon}</div>
        <h2 className="modal-title">{title}</h2>
        <p className="modal-subtitle">{subtitle}</p>
        <button className="modal-button" onClick={onClose}>{buttonText}</button>
      </div>
    </div>
  );
};

export default CompetenceTest;
